import type { SbIvyState } from '@agentic-ivy/shared-types';

/**
 * What Ivy is doing in each video, from the chat to the storyboard page (F4): the chat publishes it, the storyboard's
 * bridge reads it when its page is ready and hears every change. A window event, as storyboard-open and -seek are.
 */
const current: Record<string, SbIvyState> = {};

export function publishIvyState(conversationId: string, state: SbIvyState): void {
  if (current[conversationId] === state) return;
  current[conversationId] = state;
  window.dispatchEvent(new CustomEvent('ivy-state', { detail: { conversationId, state } }));
}

export const ivyStateOf = (conversationId: string): SbIvyState => current[conversationId] ?? 'idle';
